<template>
    <div class="byllingcycle-body">
        <div class="summary-box summary-from" :class="[variant]">
            <SubscriptionDetails
                :variant="'old'"
                :buttonVariant="oldButtonVariant"
                :enabled="variant!=='upgrade'"
                :subscription="subscription"
            />
        </div>
        <div class="downgrade-arrow" v-if="(variant !== 'manage' && variant !== 'downgrade') || oldButtonVariant === 'upgrade'">
            <font-awesome-icon icon="fa-solid fa-arrow-right" />
        </div>
        <div v-if="variant === 'upgrade' || oldButtonVariant === 'upgrade'" class="summary-box summary-to" :class="[variant]">
            <SubscriptionDetails
                :variant="oldButtonVariant === 'upgrade' ? oldButtonVariant : variant"
                :buttonVariant="'cycle'"
                :subscription="subscription"
                @changedCycle="onCycleChanged"
            />
        </div>
    </div>
</template>

<script>
import SubscriptionDetails from "@/components/subscriptions/SubscriptionDetails.vue";
import SubscriptionService from "@/store/services/subscriptions.service";

export default {
    name: "ChangeBillingCycle",
    components: {SubscriptionDetails},
    props: {
        variant: {
            type: String, // "manage", "upgrade" & "downgrade"
            default: "manage"
        }
    },
    data() {
        return {
            subscription: null
        }
    },
    created() {
        this.$nextTick(() => {
            SubscriptionService.retrieveCurrent().then((response) => {
                this.subscription = response.data;
                this.$store.commit('subscriptionStore/setSubscription', this.subscription);
                this.$emit('subscriptionLoaded', this.subscription);
            });
        })
    },
    methods: {
        onCycleChanged(val) {
            this.$emit('changedCycle', val);
        }
    },
    computed:{
        oldButtonVariant(){
            if (this.variant === "manage") {
                if (this.subscription && this.subscription.is_valid) {
                    return "dropdown"
                } else {
                    return "upgrade";
                }
            }else if (this.variant === "downgrade"){
                return "cancelled";
            }
            return "none"
        },
        newButtonVariant(){
            if (this.variant === "manage")
                return "none";
            else if (this.variant === "upgrade")
                return "cycle";
            return "none"
        }
    }
}
</script>

<style lang="scss" scoped>

.byllingcycle-body {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.summary-box {
    max-width: 620px;
    width: 100%;
    flex: 1;
    border-radius: $radiusLg;
    &.summary-from { background-color: #f6f6f6; }
    &.summary-to { background: linear-gradient(to right, #49bca0, #098566de); }
    &.summary-from.manage { 
        max-width: 500px; 
        border: 1px solid $colorBorderDash;
        background: white;
    }
}
.downgrade-arrow {
    display: flex; 
    padding: 20px 0px;
    justify-content: center;
    align-items: center;
    .svg-inline--fa { color: $colorBorderDash; font-size: 50px; }
    transform: rotate(90deg);
    width: 90px;
    @media(max-width: '767px') {
        padding: 10px 0px;
    }
}
@media (min-width: 768px) {  
    .byllingcycle-body {
        flex-direction: row;
        align-items: normal;
    }
}
@media (min-width: 1150px) {  
    .downgrade-arrow {
        padding: 0px 10px;
        transform: rotate(0deg);
    }
}

</style>

<style lang="scss">
.summary-box {
    &.summary-from.manage { 
       .billing-total {
            background: white;
            border-top: 1px solid $colorBorderDash;
       }
    }
}

</style>
